@switch (kpListType()) {
  @case (KPListType.form) {
    <app-knowledge-forms-section
      *appFormsAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.formFolder) {
    <app-knowledge-form-folders-section
      *appFormsAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.calendar) {
    <app-knowledge-calendars-section
      *appCalendarAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.contact) {
    <app-knowledge-contacts-section
      *appContactsAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.event) {
    <app-knowledge-events-section
      *appCalendarAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.file) {
    <app-knowledge-files-section
      *appFilesAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.folder) {
    <app-knowledge-folders-section
      *appFilesAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.sheetFolder) {
    <app-knowledge-sheet-folders-section
      *appSheetsAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.sheet) {
    <app-knowledge-sheets-section
      *appSheetsAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.group) {
    <app-knowledge-groups-section
      *appContactsAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.messageFolder) {
    <app-knowledge-mail-folders-section
      *appMailAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.message) {
    <app-knowledge-messages-section
      *appMailAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.notebook) {
    <app-knowledge-notebooks-section
      *appNotesAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.note) {
    <app-knowledge-notes-section
      *appNotesAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.project) {
    <app-knowledge-projects-section
      *appTaskingAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
  @case (KPListType.task) {
    <app-knowledge-tasks-section
      *appTaskingAppContext
      [stateKey]="resultsTypeStateKey"
      [tags]="resultsTags()"
      [knots]="resultsKnots()"
      [type]="kpListType()"
      [connections]="resultsConnections()"
      (itemClick)="handleClickItem($event)"
      (typeChange)="kpListType.set($event)"
    />
  }
}
